import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators ,UntypedFormControl} from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import type { ShowroomInformations } from '@app/_services/account.service';
import { DateAdapter } from '@angular/material/core';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { first } from 'rxjs/operators';
import { InstoreService, AccountService } from '@app/_services';   
import * as moment from 'moment';                                                  
import { ToastrService,IndividualConfig } from 'ngx-toastr';
import { NgxSpinnerService } from "ngx-spinner"; 
import { ConfirmDialogService } from '@app/module/confirm-dialog/confirm-dialog/confirm-dialog.service';  

@Component({
  selector: 'app-addinstore',
  templateUrl: './addinstore.component.html',
  styleUrls: ['./addinstore.component.css']
})
export class AddinstoreComponent implements OnInit {

  range = new UntypedFormGroup({
    start: new UntypedFormControl(),
    end: new UntypedFormControl()
  });

  @ViewChild("fileInput") fileInput: ElementRef;

  private format = 'YYYY-MM-DD';

  City: any = ['Option 1', 'Option 2', 'Option 3']
  form: UntypedFormGroup;
  submitted = false;
  isLoading = false;
  instoreName ="";
  RegionDataLists;
  ShowroomDataLists: ShowroomInformations[] = [];
  FloorDataLists;                                                       
  LocationDataLists;
  AssetsDataLists;
  CreativeDataLists;
  VendorDataListsl;

  FilterShowroomLists;
  selRegionValue: number;
  selShowroomValue: number;
  selFloorValue: number;
  
  user_role_id: number=0;
  user_region_id:number=0;
  user_Showroom_id:number=0;
  //isDisabled:boolean=false;
  isAdmin:boolean=false;
  install_date = new UntypedFormControl();
  minDate: any;
  todayDate:Date = new Date();

  imageError:any
  constructor(private formBuilder: UntypedFormBuilder,
    private instoreService: InstoreService,private modalService: NgbModal,
    private accountService: AccountService,private toastr: ToastrService,
    private route: ActivatedRoute, private confirmDialogService: ConfirmDialogService ,
    private dateAdapter: DateAdapter<Date>,
    private router: Router, private spinner: NgxSpinnerService) { 
        this.dateAdapter.setLocale('en-GB'); //dd/MM/yyyy
    }
    

  ngOnInit(): void {

    const max_size = 20971520;
    const allowed_types = ['image/png', 'image/jpeg'];
    
    this.route.queryParams.subscribe(params => {
    });

    this.form = this.formBuilder.group({
      location_id: ['', Validators.required], //m
      particulars: ['', Validators.required], //m
      region_id: ['', Validators.required], //m
      showroom_id: ['', Validators.required], //m
      floor_id: ['', Validators.required], //m
      asset_type_id: ['', Validators.required], //m
      creative_id: ['', Validators.required], //m
      vendor_id: ['', Validators.required], //m
      name : ['', Validators.required], //m
      size_w: ['', Validators.required], //m
      size_h: ['', Validators.required], //m
      install_date: ['', Validators.required], //m
      expiry_date: ['', Validators.required], //m
      asset_count: ['10'], //m
      image: [''],
      dummydate: [''],
    });

    this.reloadRegionLists()
    this.reloadShowroomLists()
    this.reloadAssetsLists()
    this.reloadCreativeLists()
    this.reloadVendorLists()
    
    var userdata = localStorage.getItem('userInformation');
    var parsedUserData = JSON.parse(userdata);
    if(parsedUserData) {
      this.user_role_id = parsedUserData.role_id;
      if(this.user_role_id==1 || this.user_role_id==2){
        this.isAdmin = true;
      }
      this.user_region_id = parsedUserData.region_id;
      this.user_Showroom_id = parsedUserData.showroom_id;
    }
  }

  // convenience getter for easy access to form fields
  get f() { return this.form.controls; }

  onSubmit(modal_id: string) {
    this.submitted = true;
    if(!this.form.valid){
      return;
    } 

    this.instoreName = this.form.get('name').value.trim();
    this.spinner.show();
    this.isLoading = true;


    this.form.get("install_date").setValue(moment(this.f.install_date.value).format(this.format)); //Working
    this.form.get("expiry_date").setValue(moment(this.f.expiry_date.value).format(this.format)); //Working

    const formDataNew = new FormData();   
    formDataNew.append('location_id', this.form.get('location_id').value);
    formDataNew.append('particulars', this.form.get('particulars').value);
    formDataNew.append('region_id', this.form.get('region_id').value);
    formDataNew.append('showroom_id', this.form.get('showroom_id').value);
    formDataNew.append('floor_id', this.form.get('floor_id').value);
    formDataNew.append('asset_type_id', this.form.get('asset_type_id').value);
    formDataNew.append('creative_id', this.form.get('creative_id').value);

    formDataNew.append('vendor_id', this.form.get('vendor_id').value);
    formDataNew.append('name', this.form.get('name').value.trim());
    formDataNew.append('size_w', this.form.get('size_w').value);
    formDataNew.append('size_h', this.form.get('size_h').value);
    formDataNew.append('install_date', this.form.get('install_date').value);
    formDataNew.append('expiry_date', this.form.get('expiry_date').value);
    formDataNew.append('image', this.form.get('image').value);
    formDataNew.append('asset_count', "10");
    for (var pair of formDataNew.entries()) {
      console.log(pair[0]+ ', ' + pair[1]); 
    }

    this.confirmDialogService.confirmThis('Are you sure you want to save ?', () =>  {
          
      this.isLoading = true;
      this.instoreService.addInstore(formDataNew)
      .pipe(first())
      .subscribe(
        (response) => {
          this.spinner.hide();
          if(response.state == "ERROR") {
            this.toastr.error("Instore name "+this.instoreName+" already exists in this showroom", "Warning", {timeOut: 2500});
          } else if(response.state == "SUCCESS") {
            this.openModal(modal_id);
            this.onReset()
          }
        },
        (error) => {     
          this.spinner.hide();            
          this.toastr.error("Sorry, something went wrong Please try again", "Warning");              
        }
      ); 
      }, () => {
        
      }); 

    
  }

  installChange(event) {
    if(event.value){
      //console.log("Date of Birth: " + moment(event.value).format(this.format) );
      //this.selInstallDate =  moment(event.value).format(this.format);
      //this.filterForInstore()
      this.minDate = event.value;
      this.resetExpiry();

    } else {
      //this.selInstallDate = "";
      //this.filterForInstore()
    }
  }   

  imageSrc: string;

  onFileChange(event) {

    const max_size = 100000;
    const allowed_types = ['image/png', 'image/jpeg', 'image/jpg'];


    const reader = new FileReader();
    const file:File = event.target.files[0];

    if (file.size > max_size) {
        alert("Image Size should not exceed more than 100 KB")
        return false;
    }
    
    if(event.target.files && event.target.files.length) {
      const [file] = event.target.files;
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.imageSrc = reader.result as string;
        /*
        this.form.patchValue({
          image: reader.result
        });
        */
       this.form.get('image').setValue(event.target.files[0]);
      //  console.log("onFileChange "+event.target.files[0]);
      };  
   
    }
  }
  
  onRegionChange(regionValue) {
        this.selRegionValue =  parseInt(regionValue, 10);
        // console.log(JSON.stringify(this.ShowroomDataLists)+"---onRegionChange----"+regionValue+"---"+this.selRegionValue);
        this.resetShowroom()
        this.resetFloor()
        this.resetLocation()
        this.FilterShowroomLists = this.ShowroomDataLists.filter(s => s.region_id === this.selRegionValue);
        if(!this.isAdmin){
          var selShowroomValue: number = this.user_Showroom_id;
          this.form.controls.showroom_id.setValue(this.FilterShowroomLists.filter(s => s.id === selShowroomValue)[0].id);

          this.onShowroomChange(selShowroomValue);
          //this.isDisabled = true;

          this.form.get('region_id').disable();
          this.form.get('showroom_id').disable();
        }

  }
  omit_special_char(event) {   
    var k;  
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57)); 
  }

  onShowroomChange(showroomValue) {
      this.selShowroomValue = parseInt(showroomValue, 10);
      this.resetFloor()
      this.resetLocation()
      this.reloadFloorLists()
  }
  
  onFloorChange(floorValue) {
    this.selFloorValue = parseInt(floorValue, 10);
    this.resetLocation()
    this.reloadLocationLists()
  }

  resetShowroom() {
    this.form.patchValue({
      showroom_id: ''
    });
  }

  resetExpiry() {
    this.form.patchValue({
      expiry_date: ''
    });
  }

  resetFloor() {
    this.FloorDataLists = [];
    this.form.patchValue({
      floor_id: ''
    });
  }

  resetLocation() {
    this.LocationDataLists = [];
    this.form.patchValue({
      location_id: ''
    });
  }

  reloadRegionLists(){
    this.accountService.getRegionsLists()
    .pipe(first())
      .subscribe(
      (response) => {
        this.isLoading = false;
        this.RegionDataLists = response.result;
        //for(var i = 0; i < this.RegionDataLists.length; i++){
          //console.log("this.RegionDataLists "+this.RegionDataLists[i].id);
        //}
      },
    (error) => {     
      this.isLoading = false;                               
    }
    );
  }

  reloadShowroomLists(){
    this.accountService.getShowroomLists()
    .pipe(first())
      .subscribe(
      (response) => {
        this.isLoading = false;
        this.ShowroomDataLists = response.result;


        if(!this.isAdmin){
            this.form.controls.region_id.setValue(this.user_region_id);
            this.onRegionChange(this.user_region_id)
           // this.isDisabled= false;
        }
      },
    (error) => {     
      this.isLoading = false;                               
    }
    );
  }

  reloadFloorLists(){
    this.instoreService.getFloorLists(this.selShowroomValue)
    .pipe(first())
      .subscribe(
      (response) => {
        this.isLoading = false;
        this.FloorDataLists = response.result;
        console.log("---"+this.FloorDataLists);
      },
    (error) => {     
      this.isLoading = false;                               
    }
    );
  }

  reloadLocationLists(){
    this.instoreService.getLocationLists(this.selShowroomValue, this.selFloorValue)
    .pipe(first())
      .subscribe(
      (response) => {
        this.isLoading = false;
        this.LocationDataLists = response.result;
        console.log("reloadLocationLists "+this.LocationDataLists);
      },
    (error) => {     
      this.isLoading = false;                               
    }
    );
  }

  reloadAssetsLists(){
    this.accountService.getAssetsLists()
    .pipe(first())
      .subscribe(
      (response) => {
        this.isLoading = false;
        this.AssetsDataLists = response.result;
      },
    (error) => {     
      this.isLoading = false;                               
    }
    );
  }

  reloadCreativeLists(){
    this.accountService.getCreativeLists()
    .pipe(first())
      .subscribe(
      (response) => {
        this.isLoading = false;
        this.CreativeDataLists = response.result;
      },
    (error) => {     
      this.isLoading = false;                               
    }
    );
  }
  
   reloadVendorLists(){
    this.accountService.getVendorLists()
    .pipe(first())
      .subscribe(
      (response) => {
        this.isLoading = false;
        this.VendorDataListsl = response.result;
      },
    (error) => {     
      this.isLoading = false;                               
    }
    );
  }
  onReset(){
    this.submitted = false;
    this.imageSrc = null;
    this.form.reset();
  }

  closeResult :string
  openModal(content) {
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title',size: 'md'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }

}
